import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 60px;
  margin: 0 auto;
  flex-direction:column;
  
  /* Aplica a transformação de escala */
  transform: scale(0.8);
`